import { LoadsPage } from "./LoadsPage";

/**
 * /admin/collections — manual customer → site collections.
 *
 * A copy of /admin/loads showing only manual/custom loads (never imported)
 * shipping stock FROM the customer back to one of our sites. The form treats
 * the customer as the origin and the per-site collection legs as the
 * destinations, reusing the same multi-leg model as deliveries.
 */
export function CollectionsPage() {
  return <LoadsPage direction="collection" />;
}
